import { RemoteGetAcademicOverviewData } from 'data/usecases';
import { GetAcademicOverviewData } from 'domain/usecases';
import { makeApiUrlAcademicOverviewData } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeGetAcademicOverviewData = (): GetAcademicOverviewData =>
  new RemoteGetAcademicOverviewData(
    makeApiUrlAcademicOverviewData(),
    makeAxiosHttpClient(),
  );
